import styled from '@emotion/styled'

export const TransactionsTableDescriptionCellTextWrapper = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`
